import styles from 'css/src/exports.module.scss';

import React from 'react';

type Props = {
    className?: string;
    strokeColor?: string;
    fillColor?: string;
    backgroundColor?: string;
    width?: number;
    height?: number;
};

const AnimationCirclesIcon = React.memo(function AnimationCirclesIcon({
    className,
    strokeColor = styles['allColors-color-grey-500'],
    fillColor = styles['allColors-color-grey-100'],
    backgroundColor,
    width = 48,
    height = 48,
}: Props) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {backgroundColor && <rect width="48" height="48" rx="4" fill={backgroundColor} />}
            <circle cx="34.5" cy="14.5" r="6.75" stroke={strokeColor} strokeWidth="3.5" />
            <circle
                cx="26.5"
                cy="21.5"
                r="8.75"
                fill={fillColor}
                stroke={strokeColor}
                strokeWidth="3.5"
            />
            <circle
                cx="17"
                cy="29"
                r="10.25"
                fill={fillColor}
                stroke={strokeColor}
                strokeWidth="3.5"
            />
            <rect
                x="7"
                y="37.5355"
                width="5"
                height="3.5"
                transform="rotate(-45 7 37.5355)"
                fill={fillColor}
            />
            <rect
                x="33.2234"
                y="24"
                width="5"
                height="3.5"
                transform="rotate(39.4365 33.2234 24)"
                fill={fillColor}
            />
        </svg>
    );
});

export default AnimationCirclesIcon;
